/*global paymentCommon */

const payment= paymentCommon;
payment.avs = paymentCommon.avsDesktop;
payment.isMobile = false;
